function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "tag (1)",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20793",
    d: "m6.459 1.75 5.13 5.145a.438.438 0 0 1 0 .618l-4.08 4.076a.438.438 0 0 1-.618 0L1.75 6.453V2.188a.437.437 0 0 1 .438-.437zM6.813 0H.9a.9.9 0 0 0-.9.9v5.906a.9.9 0 0 0 .263.636l6.3 6.3a.9.9 0 0 0 1.27 0l5.9-5.9a.9.9 0 0 0 0-1.27L7.449.264A.9.9 0 0 0 6.813 0z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 953",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3.52 3.52)",
    style: {
      fill: "#c4c4c4"
    }
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.5aefcf2b.svg";
export { ForwardRef as ReactComponent };